/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /data/jenkins_slave/epjenkins81/workspace/IWT-GIT/01213-Component-Loader/node_modules/lodash/_freeGlobal.js
// module id = 46
// module chunks = 0 1